import { array } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import joinClasses from 'webapp/helpers/join-classes';
import LoaderSvgComponent from 'webapp/components/loader-svg';

import type DChartPrimaryPoint from 'webapp/d-chart/point/primary-point';

export interface Args {
	model: DChartPrimaryPoint;
	loading?: boolean;
	skipClickable?: boolean;
}

export default class BlockContentCommonValueComponent<T extends Args> extends Component<T> {
	@service('timer') declare timerService: Service.Timer;

	get isLoaderShown() {
		return !!this.args.loading;
	}

	get isClickable() {
		return !!this.args.model.onClick && !this.args.skipClickable;
	}

	get showOnlyLoader() {
		// if syncing AND no value, skip showing value (-)
		return this.isLoaderShown && !this.args.model?.valueStr;
	}

	get valueFormatted() {
		if (this.args.model.isRelativeTimeFormat) {
			this.timerService.observe();
		}
		const endValue = this.args.model.valueStrFormatted;
		return htmlSafe(endValue);
	}

	@action
	handleClick(event: PointerEvent) {
		if (!this.isClickable) {
			return;
		}

		this.args.model.onClick?.(event);
	}
	<template>
		<span
			class={{joinClasses (array "bc__value" (if this.isClickable "bc__value--clickable"))}}
			{{on "click" this.handleClick}}
			role="button"
		>
			{{#if this.isLoaderShown}}
				<LoaderSvgComponent />
			{{/if}}

			{{#unless this.showOnlyLoader}}
				{{{this.valueFormatted}}}
			{{/unless}}
		</span>
	</template>
}
